/**
 * Forecast math shared by EarnedRow (Shop / Field) and TotalColumn so the
 * formulas can't drift apart.

 */
export const calculateForecastAndVariance = (budgetHrs, actualHrs, pct) => {
  const budget = Number(budgetHrs) || 0;
  const actual = Number(actualHrs) || 0;
  const percent = Number(pct) || 0;

  const forecastHrs = percent > 0 ? actual / (percent / 100) : null;
  const leftToCompleteHrs = forecastHrs !== null ? forecastHrs - actual : null;
  const budgetVarianceHrs = forecastHrs !== null ? budget - forecastHrs : null;

  return { forecastHrs, leftToCompleteHrs, budgetVarianceHrs };
};
